import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/error.js");
